import { useEffect, useState } from "react";

function TimeCounter({ initialTime = "05:17:27" }) {
  const [seconds, setSeconds] = useState(() =>
    timeStringToSeconds(initialTime)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev: any) => prev + 1);
    }, 1000);

    return () => clearInterval(interval); // Temizlik
  }, []);

  return <div>{secondsToTimeString(seconds)}</div>;
}

function timeStringToSeconds(timeStr: any) {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

function secondsToTimeString(totalSeconds: any) {
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    "0"
  );
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
}

export default TimeCounter;
